import { orchestrator } from "satcheljs";

import { toggleMemberFilter } from "../../../sh-application/components/schedules/lib";
import { resetTagsPeopleCount } from "../mutators/resetTagsPeopleCount";

export const onToggleMemberFilters = orchestrator(toggleMemberFilter, () => {
    resetTagsPeopleCount();
});
